/**
 * Flat care-seeker submit schema for LFB and legacy CareSeeker forms.
 *
 * Do not reuse `careSeekerFormSchemaBase` here — that nested step1–step5
 * shape is a different payload. Do not compose `careOptionsSchema` (it
 * requires at least one option; today's live submit accepts all-false).
 */

import { z } from "zod";
import { careRecipientSchema, urgencySchema } from "./care-seeker-form";
import {
  emailSchema,
  firstNameSchema,
  lastNameSchema,
  phoneSchema,
  postalCodeSchema,
} from "./field-validators";

const careTypeContractSchema = z.object({
  everydayTasks: z.boolean().default(false),
  memoryCare: z.boolean().default(false),
  mobilityAssistance: z.boolean().default(false),
  other: z.boolean().default(false),
});

const careSeekerContractSchema = z.object({
  careFor: careRecipientSchema.optional(),
  careType: careTypeContractSchema,
  consentTerms: z.boolean().optional(),
  email: emailSchema,
  firstName: firstNameSchema,
  lastName: lastNameSchema,
  location: postalCodeSchema,
  OptInSms: z.boolean().default(false),
  organizationNumber: z.number(),
  phone: phoneSchema,
  postalCode: postalCodeSchema,
  urgency: urgencySchema.optional(),
});

export { careSeekerContractSchema };
